import L from "leaflet";
import { Marker } from "react-leaflet";
import { Height } from "../../../services/RuteplanAPI";
import heightRestrictionIconResource from "../../../assets/heightRestrictionIcon.svg"
import { useRouteFeatureDialogStoreActions } from "../../../stores/RouteFeatureDialogStore";

const heightRestrictionIcon = L.icon({
    iconUrl: heightRestrictionIconResource,
    iconRetinaUrl: heightRestrictionIconResource,
    iconAnchor: [14, 28],
    iconSize: [28, 28]
  });

export interface IHeightRestrictionMarkersProps {
    heightRestrictions: Array<Height>;
}

export default function HeightRestrictionMarkers (props: IHeightRestrictionMarkersProps) {
    const { setClickedRoadFeature, setRoadFeatureDialogIsOpen } = useRouteFeatureDialogStoreActions();
    
    const { heightRestrictions } = props;

    return (
        <>
            {heightRestrictions.map((heightRestriction: Height, index: number) => {
                return (
                    <Marker key={heightRestriction.location!.y + "," + heightRestriction.location!.x + index}
                    position={[heightRestriction.location!.y, heightRestriction.location!.x]} 
                    icon={heightRestrictionIcon}
                    eventHandlers={{
                        click: () => {
                            setClickedRoadFeature(heightRestriction);
                            setRoadFeatureDialogIsOpen(true);
                        }
                    }}
                    />
                )
            })}
        </>
    )
}